import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getDeliveryTakeawayViews } from 'store/ProductDetails/selectors';

import TakeawayViewControls from '../TakeawayViewControls';
import TakeawayViewRouter from '../TakeawayViewRouter';
import TakeawayViewFilters from '../TakeawayViewFilters';

/**
 * Takeaway tab with switch for subviews
 */
function DeliveryTypeTakeaway({ children, tabs }) {
  return (
    <>
      {children}
      <TakeawayViewControls {...{ tabs }} />
      <>
        <TakeawayViewFilters />
        <TakeawayViewRouter {...{ tabs }} />
      </>
    </>
  );
}

DeliveryTypeTakeaway.propTypes = {
  children: PropTypes.node,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  loadingPoints: PropTypes.string,
};

const mapStateToProps = (state) => ({
  tabs: getDeliveryTakeawayViews(state),
});

export default connect(mapStateToProps)(DeliveryTypeTakeaway);
